// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2TQ_q","text":"SelectPayment_text__1Zk_o","title":"SelectPayment_title__yweNO","btn":"SelectPayment_btn__N7sYb"};